import React from 'react';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

export default function(props) {
    return (
        <ListItem
            button
            onClick={props.onClick}
            className='sidebar-link'
        >
            <ListItemText 
                classes={{primary: 'sidebar-link-text'}}
                primary={props.name} 
            />
        </ListItem>
    );
}
